function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "utility/calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stroke",
    d: "M22 8V2.81829H17.5M22 8V21H2V8M22 8H2M2 8V2.81829H6.5M10 4.63634V1M14 4.63634V1",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
SvgCalendar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgCalendar"
};
export default SvgCalendar;